import { Api } from 'src/common';
import { getUserId } from './user.service';

type Terminal = {
  terminalType: string;
  terminalName: string;
  terminalID: string;
  status: 'Active' | 'Inactive';
  terminalTypeId: number;
};

type TerminalType = {
  type: string;
  id: number;
};

export type TerminalsData = {
  terminalsArray: Terminal[];
  terminalTypesArray: TerminalType[];
};

type TerminalsResponse = {
  status: number;
  success: boolean;
  result: TerminalsData;
};

export async function getTerminals(abortController: AbortController): Promise<TerminalsData> {
  const userId = getUserId();
  const endpoint = `terminals?userReference=${userId}`;

  const result = await Api.get<TerminalsResponse>(endpoint, {
    signal: abortController.signal,
  });

  if (result && result?.response && result.status === 200) {
    return result.response.result;
  }

  if (result.status > 300 && result.status < 500) {
    throw new Error(
      "Uh oh! We're experiencing technical difficulties, but we're working on it. Please try again later.",
    );
  }

  throw new Error(
    `Get Terminals: Invalid response: ${result.status}: ${JSON.stringify(result.response)}`,
  );
}
